import { jsx as _jsx } from "react/jsx-runtime";
import MuiDivider from "@mui/material/Divider";
export function Divider(props) {
    const { orientation, variant } = props;
    return _jsx(MuiDivider, { orientation: orientation, variant: variant });
}
//# sourceMappingURL=Divider.js.map